import { Component, Injector } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { AppConfiguration } from 'src/app/app-configuration';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { UploadService } from 'src/app/core/services/upload.service';

interface AcknowledgeOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-acknowledge',
  templateUrl: './acknowledge.component.html',
  styleUrls: ['./acknowledge.component.scss']
})
export class AcknowledgeComponent extends ArtifactBaseComponent{

  selectedOption: string = '';
  options: AcknowledgeOption[] = [];
  hasOptions: boolean = false;

  constructor(
    private injector: Injector,
    private sanitizer: DomSanitizer,
  ) {
    super(injector)
  }

  initJsonData(){
    this.options = this.artifact.acknowledgeOptions || [];
    this.hasOptions = this.options.length > 0;
    if (this.hasOptions && this.jsonData?.selectedOption) {
      this.selectedOption = this.jsonData.selectedOption;
    }
  }

  validateJsonData(){}

  resetJsonData(){
    this.artifact.isArtifactUpdated = true;
    this.artifact.sectionValid = false;
    this.selectedOption = '';
  }

  override processBeforeSubmit(){
    if (this.hasOptions) {
      this.jsonData = {
        sectionValid: this.artifact.sectionValid,
        selectedOption: this.selectedOption,
        selectedLabel: this.options.find(o => o.value === this.selectedOption)?.label || ''
      };
    } else {
      this.jsonData = {sectionValid:this.artifact.sectionValid};
    }
  }

  AcknowledgeArtifactChecked(){
    this.artifact.isArtifactUpdated = true;
    this.validateSection();
  }

  onOptionSelected(value: string){
    this.selectedOption = value;
    this.artifact.sectionValid = true;
    this.artifact.isArtifactUpdated = true;
    this.validateSection();
  }

  getSafeHtml(html: string | undefined): SafeHtml {
    if (html) {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } else {
      return "";
    }
  }
}
